import { render, staticRenderFns } from "./Programs.vue?vue&type=template&id=0d082c71"
import script from "./Programs.vue?vue&type=script&lang=js"
export * from "./Programs.vue?vue&type=script&lang=js"
import style0 from "./Programs.vue?vue&type=style&index=0&id=0d082c71&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports